import axios from "./Axios";
import {UCP_URL} from "../config";

class Person {
    static async updatePersonProperties({personId, properties, appClientId }) {
        const { data, errors } = await axios()({
            url: UCP_URL + '/update_customer_props/'+personId,
            method: 'POST',
            responseType: 'json',
            data: {
                properties,
                appClientId
            }
        });
        if (errors && errors.length) {
            throw errors[0]
        }
        return data;
    }

    static async sendCode({ ...payload }) {
        const { data } = await axios()({
            url: UCP_URL + '/messenger-auth/send-code',
            method: 'POST',
            responseType: 'json',
            data: {
                ...payload
            }
        });
        const { status, message, sourcePersonId } = data;
        if (!status) {
            throw new Error(message)
        }

        return {
            status,
            message,
            sourcePersonId,
        };
    }

    static async verifyCode({ ...payload }) {
        const { data } = await axios()({
            url: UCP_URL + '/messenger-auth/verify-code',
            method: 'POST',
            responseType: 'json',
            data: {
                ...payload
            }
        });
        const { status, message, encryptedData, userProperties } = data;
        if (!status) {
            throw new Error(message)
        }

        return {
            status,
            message,
            encryptedData,
            userProperties
        };
    }

    static async tryOrderLogin({ ...payload }) {
        const { data } = await axios()({
            url: UCP_URL + '/messenger-auth/try-order-login',
            method: 'POST',
            responseType: 'json',
            data: {
                ...payload
            }
        });

        const { status, message, encryptedData, userProperties } = data;

        if (!status) {
            throw new Error(message)
        }

        return {
            status,
            message,
            encryptedData,
            userProperties
        };
    }
}

export default Person